import React, { useEffect, useRef, useState } from 'react';
import Lottie from 'react-lottie';
import c from './render-animation.module.scss';

// add new .json file to assets\lotties
// import .json into file where component is being used
// pass .json through to RenderAnimation as lottieFile attribute
const RenderAnimation = ({
  lottieFile,
  className,
  aspectRatio,
  loop = false,
}) => {
  const lottieRef = useRef();
  const query = '(prefers-reduced-motion: no-preference)';
  const aniPrefQuery = !window.matchMedia(query).matches;
  const [prefersReducedAnimation, setPrefersReducedAnimation] =
    useState(aniPrefQuery);
  const loopRef = useRef(!prefersReducedAnimation && loop);

  // Handle a sequence of the smaller animation for performance
  const [currentPart, setCurrentPart] = useState(0); // Track animation sequence
  // Ensure animation is always an array
  const animations = Array.isArray(lottieFile) ? lottieFile : [lottieFile];

  // Reset currentPart when animation changes
  useEffect(() => {
    setCurrentPart(0);
  }, [lottieFile]);

  const handleAnimationComplete = () => {
    if (currentPart < animations.length - 1) {
      setCurrentPart(currentPart + 1); // Play next animation part
    } else if (loop) {
      setCurrentPart(0); // Restart from the first part if looping is enabled
    }
  };

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const listener = (event) => {
      setPrefersReducedAnimation(!event.matches);
    };
    mediaQueryList.addEventListener('change', listener);

    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, []);

  useEffect(() => {
    if (prefersReducedAnimation) {
      loopRef.current = false;
      lottieRef.current.anim.stop();
      const duration = lottieRef?.current?.anim.getDuration(true);
      lottieRef?.current?.anim.goToAndStop(duration - 1, true);
    }
    if (!prefersReducedAnimation) {
      loopRef.current = loop;
    }
  }, [prefersReducedAnimation, loop]);

  const defaultOptions = {
    loop: loopRef.current,
    autoplay: !prefersReducedAnimation,
    animationData: animations[currentPart],
    rendererSettings: {
      preserveAspectRatio: aspectRatio || 'xMidYMid meet',
    },
  };
  const defaultStyle = {
    height: '100%',
  };
  return (
    <div inert="" aria-hidden="true" className={`${c.animation} ${className}`}>
      <Lottie
        ref={lottieRef}
        options={defaultOptions}
        ariaRole="presentation"
        isClickToPauseDisabled={true}
        eventListeners={[
          { eventName: 'complete', callback: handleAnimationComplete }, // Move to the next animation on complete
        ]}
        style={defaultStyle}
      />
    </div>
  );
};
export default RenderAnimation;
